module.exports = __webpack_public_path__ + "assets/img/TG-LOGO.3903a46e.png";